import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=5607bdf6&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style0 from "./balance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./balance.vue?vue&type=style&index=1&id=5607bdf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607bdf6",
  null
  
)

export default component.exports